import { render, staticRenderFns } from "./beiwan.vue?vue&type=template&id=d2a7603a&scoped=true&"
import script from "./beiwan.vue?vue&type=script&lang=js&"
export * from "./beiwan.vue?vue&type=script&lang=js&"
import style0 from "./beiwan.vue?vue&type=style&index=0&id=d2a7603a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a7603a",
  null
  
)

export default component.exports